import {
    faCheckCircle,
    faTimesCircle
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ET3Div from "../../et3-div";
import Et3Text from "../../et3-text";
import {
    E_ADMIN_ROLE,
    E_KHATTABAT_ASSIGN_CLIENT_USER_TYPE, TUserType,
} from "../../../Types";
import { withLiteObserverAndTheme } from "../../et3-enhanced-render";
import { getKhattabatAssignStore } from "../../../stores/khattabat-stores/assign-store";
import getCorePopUpStore from "../../../stores/core/core-popup-store";
import i18n from "../../../constants/i18n";
import getDashBoardStore from "../../../stores/dashboard-store";
import { reduce } from "et3-type-guards";
import getCorePersonalStore from "../../../stores/core/core-personal-store";

const KhattabatAssignClientOption = withLiteObserverAndTheme<{
    clientType: TUserType;
}>((props) => {
    const { theme, clientType } = props;
    const { colors } = theme;

    const selectedClientType =
        getKhattabatAssignStore().selectedClientType.get();


    const isChecked = selectedClientType === clientType;

    const isTester =
        clientType === E_KHATTABAT_ASSIGN_CLIENT_USER_TYPE.TESTER;

    const userRole = reduce(() => getCorePersonalStore().user.get().role, "");
    const isKhattabaTesterRole = userRole === E_ADMIN_ROLE.KHATTABA_ADMIN_TESTER;
    const isDisabled = !isKhattabaTesterRole && isTester;

    const label = isTester
        ? i18n.get("KHATTABAT_ASSIGN_TESTER_USERS")
        : i18n.get("KHATTABAT_ASSIGN_REAL_USERS");

    const count = isTester
        ? getDashBoardStore().totalUnassignedKhattabatTesters.get()
        : getDashBoardStore().totalUnassignedKhattabatClients.get();

    return (
        <ET3Div
            isScrollable={false}
            isExtendable={false}
            fDirection="row"
            justifyContent="flex-start"
            alignItems="center"
            withShadow={false}
            width={420}
            height={70}
            color={colors.all.transparent}
            style={{
                cursor: isDisabled ? "not-allowed" : "pointer",
                opacity: isDisabled ? 0.45 : 1,
                border: isTester
                    ? `2px dotted ${colors.all.red}`
                    : "2px dotted transparent",
                borderRadius: 35,
                paddingLeft: 20
            }}
            onClick={() => {
                if (!isDisabled && !isChecked) {
                    getKhattabatAssignStore().toggleSelectedClientType();
                }
            }}
        >
            <input
                type="checkbox"
                checked={isChecked}
                disabled={isDisabled}
                onChange={() => {
                    if (!isDisabled && !isChecked) {
                        getKhattabatAssignStore().toggleSelectedClientType();
                    }
                }}
                onClick={(event) => {
                    event.stopPropagation();
                }}
                style={{
                    width: 28,
                    height: 28,
                    marginRight: 18,
                    cursor: isDisabled ? "not-allowed" : "pointer",
                    accentColor: isTester && isChecked ? colors.all.red : undefined
                }}
            />

            <Et3Text
                fontFamily={"MEDIUM"}
                fontSize={22}
                text={`${label} (${count})`}
                isSpan={false}
                color={isTester ? colors.all.red : colors.all.black}
                style={{}}
            />
        </ET3Div>
    );
});

export const KhattabatAssignClientTypeSelector = withLiteObserverAndTheme(
    (props) => {
        const { theme } = props;
        const { colors } = theme;

        return (
            <ET3Div
                isScrollable={false}
                isExtendable={false}
                fDirection="column"
                justifyContent="center"
                alignItems="center"
                withShadow={false}
                width={500}
                height={160}
                color={colors.all.transparent}
                style={{}}
                onClick={() => { }}
            >

                <KhattabatAssignClientOption clientType={E_KHATTABAT_ASSIGN_CLIENT_USER_TYPE.TESTER} />

                <KhattabatAssignClientOption clientType={E_KHATTABAT_ASSIGN_CLIENT_USER_TYPE.REAL} />
            </ET3Div>
        );
    })

export const KhattabatAssignClientActions = withLiteObserverAndTheme((props) => {
    const { theme } = props;
    const { colors } = theme;

    return (
        <ET3Div
            isScrollable={false}
            isExtendable={true}
            fDirection="row"
            justifyContent="space-between"
            alignItems="center"
            withShadow={false}
            width={500}
            height={100}
            color={colors.all.transparent}
            style={{}}
            onClick={() => { }}
        >
            <FontAwesomeIcon
                className="clickable"
                onClick={() => {
                    getKhattabatAssignStore().assignClientToKhattaba();
                }}
                icon={faCheckCircle}
                color={colors.all.green}
                style={{}}
                size="3x"
            />

            <FontAwesomeIcon
                className="clickable"
                onClick={() => {
                    getCorePopUpStore().closeConfirmationPopUps();
                }}
                icon={faTimesCircle}
                color={colors.all.red}
                style={{}}
                size="3x"
            />
        </ET3Div>
    );
});
